<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      app
      dark
      clipped
    >
      <v-list v-if="user">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">{{ user.firstname }} {{ user.lastname }}</v-list-item-title>
            <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click="logout()"><v-icon>mdi-logout</v-icon></v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-divider v-if="user"></v-divider>
      <v-list dense v-if="user">
        <v-list-item link :to="{ name: 'Search' }">
          <v-list-item-action>
            <v-icon>mdi-magnify</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Search</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'BomsCreate' }">
          <v-list-item-action>
            <v-icon>mdi-format-list-text</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>BOM</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'Articles' }">
          <v-list-item-action>
            <v-icon>mdi-database</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Articles</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'OrdersList' }">
          <v-list-item-action>
            <v-icon>mdi-cart</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Orders</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'Suppliers' }">
          <v-list-item-action>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Suppliers</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list v-else>
        <v-list-item link :to="{ name: 'Login' }">
          <v-list-item-action>
            <v-icon>mdi-login</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Sign in</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list dense>
        <v-list-item link :to="{ name: 'Api' }">
          <v-list-item-action>
            <v-icon>mdi-api</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>API</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider v-if="isAdmin"></v-divider>
      <v-subheader v-if="isAdmin">Administration</v-subheader>
      <v-list dense v-if="isAdmin">
        <v-list-item link :to="{ name: 'Users' }">
          <v-list-item-action>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Users</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="primary"
      dark
      clipped-left
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-app-bar>

    <v-content class="mb-8">
      <keep-alive>
        <router-view/>
      </keep-alive>
    </v-content>

    <v-footer fixed>
      <v-spacer></v-spacer>
      <span class="caption">
        Stéphane RATELET
      </span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'App',
  data: () => ({
    drawer: null,
    title: process.env.VUE_APP_TITLE
  }),
  methods: {
    ...mapActions(['me', 'logout'])
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['isAdmin'])
  },
  mounted () {
    this.me()
  },
  watch: {
    user () {
      if (this.user) {
        this.$router.push({ name: 'Search' })
      } else {
        this.$router.push({ name: 'Login' })
      }
    }
  }
}
</script>
